import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as farStar } from '@fortawesome/pro-regular-svg-icons';
import { faStar } from '@fortawesome/pro-solid-svg-icons';

import { setPrimaryOwner } from '../store/actions/owners';
import { connect } from 'react-redux';


function PrimaryToggle({ owner, setPrimaryOwner }) {
  const { primary } = owner;
  const [primaryHover, setPrimaryHover] = useState(false);

  const primaryButtonTooltip = (
    <Tooltip id={`ownership-primary-button-${owner.id}`} show={primaryHover}>
      {primary ? 'Remove Primary' : 'Make Primary'}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      overlay={primaryButtonTooltip}
      onEnter={() => setPrimaryHover(true)}
      onExit={() => setPrimaryHover(false)}
    >
      <Button className="btn-icon" variant="link" onClick={() => setPrimaryOwner(owner.id, !primary)}>
        {primary ? (
          <FontAwesomeIcon className="text-secondary" icon={faStar}/>
        ) : (
          <FontAwesomeIcon className="text-muted" icon={primaryHover ? faStar : farStar}/>
        )}
      </Button>
    </OverlayTrigger>
  );
}

PrimaryToggle.propTypes = {
  owner: PropTypes.shape({
    id: PropTypes.number.isRequired,
    primary: PropTypes.bool.isRequired
  }),
  setPrimaryOwner: PropTypes.func.isRequired
};

export default connect(null, { setPrimaryOwner })(PrimaryToggle);
